<div id="commuinty-wrapper">
    <app-area-header
        largeHeadline="{{
            'project.components.communityProject.largeHeadline'
                | translate
        }}"
        [smallHeadlineTranslationKey]="smallHeadlineTranslationKey"
        [profilePicture]="headerPicture"
        [round]="false"
    ></app-area-header>
    <div class="container-fluid gallery-controls">
        <div class="row">
            <div
                class="col-12 d-flex justify-content-between align-items-center gallery-controls-row"
            >
                <div class="filter-chips-container">
                    <div
                        class="filter-chip motoric"
                        [class.active]="
                            currentFilter.includes(
                                ContainerType.PROJECT_MOTORIC
                            )
                        "
                        (click)="changeFilter(ContainerType.PROJECT_MOTORIC)"
                        *ngIf="authService.hasMotoricTrainingRights()"
                    >
                        <img
                            src="assets/svg/sidebar-nav/motoric-icon.svg"
                            alt="motoric icon"
                            class="filter-chip-icon"
                        />
                        <span class="filter-chip-text">
                            {{
                                'project.components.communityProject.chips.motoric'
                                    | translate
                            }}
                        </span>
                    </div>
                    <div class="chip-spacer"></div>
                    <div
                        class="filter-chip visual"
                        [class.active]="
                            currentFilter.includes(ContainerType.PROJECT_VISUAL)
                        "
                        (click)="changeFilter(ContainerType.PROJECT_VISUAL)"
                        *ngIf="authService.hasVisualTrainingRights()"
                    >
                        <img
                            src="assets/svg/sidebar-nav/visual-icon.svg"
                            alt="visual icon"
                            class="filter-chip-icon"
                        />
                        <span class="filter-chip-text">
                            {{
                                'project.components.communityProject.chips.visual'
                                    | translate
                            }}
                        </span>
                    </div>
                    <div class="chip-spacer"></div>
                    <div
                        class="filter-chip imgDb"
                        [class.active]="
                            currentFilter.includes(ContainerType.IMAGE_DB)
                        "
                        (click)="changeFilter(ContainerType.IMAGE_DB)"
                        *ngIf="authService.hasVisualTrainingRights()"
                    >
                        <img
                            src="assets/svg/sidebar-nav/picdatabase-icon.svg"
                            alt="database icon"
                            class="filter-chip-icon"
                        />
                        <span class="filter-chip-text">
                            {{
                                'project.components.communityProject.chips.imgDb'
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
                <div class="chip-spacer"></div>
                <div class="controls-right">
                    <button
                        class="btn remove-filter-btn"
                        [disabled]="removeFilterButtonDisabled()"
                        (click)="removeFilter()"
                    >
                        {{
                            'project.components.communityProject.removeFilter'
                                | translate
                        }}
                    </button>
                    <app-container-search-field
                        [placeholderTranslationKey]="
                            'project.components.communityProject.searchPlaceholder'
                        "
                        [initialSearchText]="searchText"
                        [width]="'dynamic'"
                        [initialSortOption]="'new-old'"
                        [resetTrigger$]="resetSearchTrigger$"
                        type="gallery"
                        (searchChanged)="onSearchChanged($event)"
                    ></app-container-search-field>
                </div>
            </div>
        </div>
    </div>
    <div
        *ngIf="searchText && searchText.length > 0"
        class="d-flex flex-row justify-content-start search-results-container"
    >
        <span class="search-results-text"
        >{{
                'workspace.components.containerOverview.searchResultsPrefix'
                    | translate
            }}
            <span class="search-term">{{ searchText }}</span>
            {{
                'workspace.components.containerOverview.searchResultsSuffix'
                    | translate
            }}</span
        >
        <span
            class="reset-search-button"
            (click)="onSearchCleared()"
            (keyup.enter)="onSearchCleared()"
        >{{
                'workspace.components.containerOverview.resetSearch' | translate
            }}</span
        >
    </div>
    <div class="container-fluid gallery-card-container">
        <div
            class="d-flex justify-content-center align-items-center h-100"
            *ngIf="showLoadingSpinner"
        >
            <div class="tryb-design-spinner"></div>
        </div>
        <app-card-page
            *ngIf="!showLoadingSpinner"
            [cardPage]="cardPage"
        ></app-card-page>
    </div>
</div>
